// extracted by mini-css-extract-plugin
module.exports = {"left":"b1ddd01198--left--qc2YY","right":"b1ddd01198--right--c9Juq"};